import { NgModule } from '@angular/core';
import { DatePickerComponent } from './date-picker/datepicker.component';
import { DisplayErrorComponent } from './error/display-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MainLayoutFooterComponent } from '../shared/common/layout/main-layout-footer/main-layout-footer.component';
import { MainLayoutHeaderComponent } from '../shared/common/layout/main-layout-header/main-layout-header.component';
import { QuestionComponent } from '@app/shared/common/question/question.component';
import { NavTabComponent } from '@app/shared/common/nav-tab/nav-tab.component';
import { EmailComponent } from '@app/shared/common/email/email.component';
import { RadioComponent } from '@app/shared/common/radio/radio.component';
import { KidComponent } from '@app/shared/common/kid/kid.component';
import { DobComponent } from '@app/shared/common/dob/dob.component';
import { RouterModule } from '@angular/router';
import { PopupContent } from '@app/shared/common/popup-content/popup-content.component';
import { MyNeedsPipe } from '@app/shared/common/pipes/my-needs.pipe';
import { SliderCustomIconComponent, SingleSliderComponent, SliderTicksLabelsComponent } from '@app/shared/slider';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { AreaChartComponent } from '@app/shared/common/area-chart/area-chart.component';
import { GaugeChartComponent } from '@app/shared/common/gauge-chart/gauge-chart';
import 'hammerjs';
import { MyDatePickerModule } from 'mydatepicker';
import { MatSliderModule } from '@angular/material';
import { RangeAreaChartMySavingComponent } from '@app/shared/common/range-area-chart-my-saving/range-area-chart-my-saving.component';
import { RangeAreaChartIncomeProtectionComponent } from '@app/shared/common/range-area-chart-income-protection/range-area-chart-income-protection.component';

@NgModule({
  declarations: [
    DatePickerComponent,
    DisplayErrorComponent,
    MainLayoutFooterComponent,
    MainLayoutHeaderComponent,
    EmailComponent,
    RadioComponent,
    DobComponent,
    KidComponent,
    QuestionComponent,
    NavTabComponent,
    PopupContent,
    MyNeedsPipe,
    SliderCustomIconComponent,
    RangeAreaChartMySavingComponent,
    SingleSliderComponent,
    AreaChartComponent,
    GaugeChartComponent,
    SliderTicksLabelsComponent,
    RangeAreaChartIncomeProtectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ChartsModule,
    MyDatePickerModule,
    MatSliderModule
  ],
  exports: [
    DatePickerComponent,
    DisplayErrorComponent,
    MainLayoutFooterComponent,
    MainLayoutHeaderComponent,
    EmailComponent,
    RadioComponent,
    DobComponent,
    KidComponent,
    QuestionComponent,
    NavTabComponent,
    PopupContent,
    MyNeedsPipe,
    SliderCustomIconComponent,
    RangeAreaChartMySavingComponent,
    SingleSliderComponent,
    AreaChartComponent,
    GaugeChartComponent,
    SliderTicksLabelsComponent,
    MatSliderModule,
    RangeAreaChartIncomeProtectionComponent
  ]
})
export class ShareModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts